module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAaCAMAAACAXYxPAAAAZlBMVEVHcEz7VSb4YTX+c0z/dE39XzL9ZDf9YDP+aT//cEj9ViT8Wiv8Vyf9ZDj/c0z+a0H9YTT8XS//////b0f/bUX7VCT+cEn9aD79Zzz+08f+9vT+3dP+hWT+wrH+5+D9nYL9pYz9lXfPYjBgAAAAC3RSTlMApBGkcZAwf1H12ZqpTY8AAACPSURBVCjPndDdDsIgDAVg9pPJHGMDp45SmL7/S0qGiavlwnguv9CeBiG60yedyJFKDYMx8zyO672XGc9HnJasV4LTRRZw2ZXhrS2hbkuoM25gU8DhEZ0F72NiJOjTOFobGK7ROoYavl5CCC610Z174pO2R0TU9M530b+4wYNj8UN+QsWxFxXHRtSVodg39QvK3iBQFe31gQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/online_service/pdf.png
// module id = QiU6
// module chunks = 1